// Imports
import axios from "axios";
require("../../../setup/config/apiConfig");

export const RESET = "RESET";

export const GET_PROPERTY_UTILITIES = "GET_PROPERTY_UTILITIES";
export const GET_PROPERTY_UTILITIES_RESPONSE =
  "GET_PROPERTY_UTILITIES_RESPONSE";
export const GET_PROPERTY_UTILITIES_RESPONSE_FAIL =
  "GET_PROPERTY_UTILITIES_RESPONSE_FAIL";

export const GET_PROPERTY_UTILITY = "GET_PROPERTY_UTILITY";
export const GET_PROPERTY_UTILITY_RESPONSE = "GET_PROPERTY_UTILITY_RESPONSE";
export const GET_PROPERTY_UTILITY_FAIL = "GET_PROPERTY_UTILITY_FAIL";

export const POST_PROPERTY_UTILITY = "POST_PROPERTY_UTILITY";
export const POST_PROPERTY_UTILITY_RESPONSE = "POST_PROPERTY_UTILITY_RESPONSE";
export const POST_PROPERTY_UTILITY_FAIL = "POST_PROPERTY_UTILITY_FAIL";

export const PUT_PROPERTY_UTILITY = "PUT_PROPERTY_UTILITY";
export const PUT_PROPERTY_UTILITY_RESPONSE = "PUT_PROPERTY_UTILITY_RESPONSE";
export const PUT_PROPERTY_UTILITY_FAIL = "PUT_PROPERTY_UTILITY_FAIL";
export const UPDATE_PROPERTY_UTILITY_LOCAL_STATE = "UPDATE_PROPERTY_UTILITY_LOCAL_STATE";


export function updatePropertyUtilityLocalState(newPropertyUtility) {
  return { type: UPDATE_PROPERTY_UTILITY_LOCAL_STATE, newPropertyUtility }
}



export function get(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_PROPERTY_UTILITIES,
      isLoading: isLoading,
    });
    return axios
      .get(`/propertyUtility`)
      .then((response) => {
        dispatch({
          type: GET_PROPERTY_UTILITIES_RESPONSE,
          propertyUtilities: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PROPERTY_UTILITIES_RESPONSE_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getByPropertyId(id, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_PROPERTY_UTILITY,
      isLoading: isLoading,
    });
    return axios
      .get(`/propertyutility/property/${id}`)
      .then((response) => {
        dispatch({
          type: GET_PROPERTY_UTILITY_RESPONSE,
          propertyUtility: response.data[0], // TODO: fix
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PROPERTY_UTILITY_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function post(u, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_PROPERTY_UTILITY,
      isLoading,
    });
    return axios
      .post("/propertyutility/", u)
      .then((response) => {
        dispatch({
          propertyUtility: response.data,
          type: POST_PROPERTY_UTILITY_RESPONSE,
        });
      })
      .catch((error) => {
        //console.log(error);
        dispatch({
          type: POST_PROPERTY_UTILITY_FAIL,
          error: error,
        });
      });
  };
}

export function put(u, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: PUT_PROPERTY_UTILITY,
      isLoading,
    });
    return axios
      .put("/propertyutility/" + u.uuid, u)
      .then((response) => {
        dispatch({
          propertyUtility: response.data,
          type: PUT_PROPERTY_UTILITY_RESPONSE,
        });
      })
      .catch((error) => {
        //console.log(error);
        dispatch({
          type: PUT_PROPERTY_UTILITY_FAIL,
          error: error,
        });
      });
  };
}
